import { Link } from "react-router-dom";
import { Card } from "semantic-ui-react";

const AdminPage = () => (
    <Card fluid className="card-form">
        <Card.Content>
            <Link to="/auth/users/">Usuários</Link>
        </Card.Content>
    </Card>)


export default AdminPage